import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.typed-array.sort.js";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { toUint8 } from '../../../base/common/uint.js';
/**
 * A fast character classifier that uses a compact array for ASCII values.
 */

export var CharacterClassifier = /*#__PURE__*/function () {
  function CharacterClassifier(_defaultValue) {
    _classCallCheck(this, CharacterClassifier);

    var defaultValue = toUint8(_defaultValue);
    this._defaultValue = defaultValue;
    this._asciiMap = CharacterClassifier._createAsciiMap(defaultValue);
    this._map = new Map();
  }

  _createClass(CharacterClassifier, [{
    key: "set",
    value: function set(charCode, _value) {
      var value = toUint8(_value);

      if (charCode >= 0 && charCode < 256) {
        this._asciiMap[charCode] = value;
      } else {
        this._map.set(charCode, value);
      }
    }
  }, {
    key: "get",
    value: function get(charCode) {
      if (charCode >= 0 && charCode < 256) {
        return this._asciiMap[charCode];
      } else {
        return this._map.get(charCode) || this._defaultValue;
      }
    }
  }], [{
    key: "_createAsciiMap",
    value: function _createAsciiMap(defaultValue) {
      var asciiMap = new Uint8Array(256);

      for (var i = 0; i < 256; i++) {
        asciiMap[i] = defaultValue;
      }

      return asciiMap;
    }
  }]);

  return CharacterClassifier;
}();
export var CharacterSet = /*#__PURE__*/function () {
  function CharacterSet() {
    _classCallCheck(this, CharacterSet);

    this._actual = new CharacterClassifier(0
    /* False */
    );
  }

  _createClass(CharacterSet, [{
    key: "add",
    value: function add(charCode) {
      this._actual.set(charCode, 1
      /* True */
      );
    }
  }, {
    key: "has",
    value: function has(charCode) {
      return this._actual.get(charCode) === 1
      /* True */
      ;
    }
  }]);

  return CharacterSet;
}();